export default "//static.tradera.net/touchweb/static/output/images/phone-mobile.766437b4.png";